import { Action } from '@ngrx/store';

import { Review } from '../review';

export enum RequestReviewActionTypes {
  REQUEST_REVIEW_SHOW_MODAL = '[Request review] show modal',
  REQUEST_REVIEW_SEND_REQUEST = '[Request review] send review request',
  REQUEST_REVIEW_SEND_REQUEST_SUCCEEDED = '[Request review] send review request succeeded',
  REQUEST_REVIEW_SEND_REQUEST_FAILED = '[Request review] send review request failed',
  REQUEST_REVIEW_HIDE_MODAL = '[Request review] hide modal',
}

export interface ListIdPayload {
  listId: string;
}

export class RequestReviewShowModalAction implements Action {
  readonly type = RequestReviewActionTypes.REQUEST_REVIEW_SHOW_MODAL;

  constructor(public payload: ListIdPayload) {}
}

export class RequestReviewSendRequestAction implements Action {
  readonly type = RequestReviewActionTypes.REQUEST_REVIEW_SEND_REQUEST;

  constructor(public payload: ListIdPayload) {}
}

export interface ReviewPayload extends ListIdPayload {
  review: Review;
}

export class RequestReviewSucceededAction implements Action {
  readonly type =
    RequestReviewActionTypes.REQUEST_REVIEW_SEND_REQUEST_SUCCEEDED;

  constructor(public payload: ReviewPayload) {}
}

export interface RequestReviewFailedPayload extends ListIdPayload {
  error: any;
}

export class RequestReviewFailedAction implements Action {
  readonly type = RequestReviewActionTypes.REQUEST_REVIEW_SEND_REQUEST_FAILED;

  constructor(public payload: RequestReviewFailedPayload) {}
}

export class RequestReviewHideModalAction implements Action {
  readonly type = RequestReviewActionTypes.REQUEST_REVIEW_HIDE_MODAL;

  constructor() {}
}

export type RequestReviewActions =
  | RequestReviewShowModalAction
  | RequestReviewSendRequestAction
  | RequestReviewSucceededAction
  | RequestReviewFailedAction
  | RequestReviewHideModalAction;
